<template>
	<div id="">
		
		<i class="iconfont icon-zhifubao" style="display: block; color: rgb(3, 160, 233); font-size: 60px; margin-top: 16%;"></i>
		<h5 style="margin-top: 20%; font-size: 30px;">欢迎使用支付宝支付!!!</h5>
		
		<div v-html="htmlbox" style="width: 100vh; height: 100%;"></div>
	</div>
</template>

<script>
	import utilFile from "@/ace/ace.js";
	export default {
	
	  components:{
	  },
      data(){
        return{
          htmlbox:'',
        }
      },

      methods:{
        fetchVideoPay(){
        	
        	var mode;
        	
        	if(this.$route.query.mode=='recharge'){
        		mode = 'recharge';
        	}else{
        		mode = 'video';
        	}
        	var data = utilFile.encrypt(JSON.stringify({
				id: localStorage.baoid,
				pay_from: "pc",
				pay_type: mode
			}));
			this.$axios({
                method: 'post',
                url: `/api/join.alipay?parameter=${data}`,
                data:{},
                withCredentials: true,
			    headers: {
			        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
			    }
                
        }).then((res)=>{
				
         		 var paras = document.forms;

				 for(var i=0;i<paras.length;i++){
				    if (paras[i] != null)
				
				     paras[i].parentNode.removeChild( paras[i]);
				
				 }
				 const div = document.createElement('div');
				 div.innerHTML = JSON.parse(utilFile.decrypt(res.data.data)).data;

			     document.body.appendChild(div);
			     document.forms[0].submit();
            	localStorage.removeItem('baoid');
            })	
        }
      },
      mounted(){
      
      	this.fetchVideoPay()

      }
    }
</script>

<style>
</style>